export default __webpack_public_path__ + "static/media/elo-logo.0c722505.png";